import React from 'react'
import StorageDataModelSource from '../../../npo-start-player-web/src/storage/data-model/source/storage-data-model-source'
import Storage from '../../../npo-start-player-web/src/storage/storage'
import App from '../../App'
import FormButton from '../../components/form/form-button/FormButton'
import FormOptions from '../../components/form/options/FormOptions'
import FormText from '../../components/form/text/FormText'
import TabsRow from '../../components/tabs/row/TabsRow'
import './app-tab-source.scss'

/**
 * The source tab within the app.
 * 
 * @author Stan Hurks
 */
export default class AppTabSource extends React.Component<any, StorageDataModelSource> {
   
    constructor(props: any) {
        super(props)

        this.state = this.getState()
    }

    public render = () => {
        return (
            <div className="app-tab-source">
                <div className="app-tab-source-streaming-protocol-drm">
                    <div className="app-tab-source-streaming-protocol-drm-left">
                    <TabsRow label="PRID" labelWidth={75}>
                        <FormText
                            value={this.state.prid}
                            onChange={(prid) => {
                                this.setState({
                                    prid
                                }, () => {
                                    Storage.data.source.prid = prid
                                })
                            }}
                            onBlur={() => {
                                this.loadSource()
                            }} />
                        </TabsRow>
                        <TabsRow label="Protocol" labelWidth={75}>
                            <FormOptions 
                                values={['auto', 'dash', 'dash_u', 'hls', 'progressive', 'smooth']} 
                                value={this.state.protocol}
                                onChange={(protocol) => {
                                    this.setState({
                                        protocol
                                    }, () => {
                                        Storage.data.source.protocol = protocol
                                        this.loadSource()
                                    })
                                }}
                                />
                        </TabsRow>
                    </div>
                    <div className="app-tab-source-streaming-protocol-drm-right">
                        <TabsRow label="DRM" labelWidth={75}>
                            Content unavailable.
                        </TabsRow>
                    </div>
                </div>
                <TabsRow label="Title">
                    <FormText
                        value={this.state.title}
                        onChange={(title) => {
                            this.setState({
                                title
                            }, () => {
                                Storage.data.source.title = title
                            })
                        }}
                        onBlur={() => {
                            this.loadSource()
                        }} />
                </TabsRow>
                <TabsRow label="Description">
                    <FormText
                        value={this.state.description}
                        onChange={(description) => {
                            this.setState({
                                description
                            }, () => {
                                Storage.data.source.description = description
                            })
                        }}
                        onBlur={() => {
                            this.loadSource()
                        }} />
                </TabsRow>
                <TabsRow label="Thumbnail (URL)">
                    <FormText
                        value={this.state.thumbnailTrackURL}
                        onChange={(thumbnailTrackURL) => {
                            this.setState({
                                thumbnailTrackURL
                            }, () => {
                                Storage.data.source.thumbnailTrackURL = thumbnailTrackURL
                            })
                        }}
                        onBlur={() => {
                            this.loadSource()
                        }} />
                </TabsRow>
                <TabsRow label="Poster">
                    <FormText
                        value={this.state.poster}
                        onChange={(poster) => {
                            this.setState({
                                poster
                            }, () => {
                                Storage.data.source.poster = poster
                            })
                        }}
                        onBlur={() => {
                            this.loadSource()
                        }} />
                </TabsRow>
                <TabsRow label="Subtitle (URL)">
                    <FormText
                        value={this.state.subtitleURL}
                        onChange={(subtitleURL) => {
                            this.setState({
                                subtitleURL
                            }, () => {
                                Storage.data.source.subtitleURL = subtitleURL
                            })
                        }}
                        onBlur={() => {
                            this.loadSource()
                        }} />
                </TabsRow>
                <TabsRow label="">
                    <FormButton onClick={() => {
                        StorageDataModelSource.reset()

                        this.setState(this.getState(), () => {
                            this.loadSource()
                        })
                    }}>
                        Reset to default
                    </FormButton>
                </TabsRow>
            </div>
        )
    }

    /**
     * Get the state
     */
    private getState = (): StorageDataModelSource => {
        return {
            title: Storage.data.source.title,
            description: Storage.data.source.description,
            protocol: Storage.data.source.protocol,
            prid: Storage.data.source.prid,
            thumbnailTrackURL: Storage.data.source.thumbnailTrackURL,
            poster: Storage.data.source.poster,
            subtitleURL: Storage.data.source.subtitleURL,
        }
    }

    /**
     * Load the source
     */
    private loadSource = () => {
        App.player!.load({
            title: this.state.title,
            description: this.state.description,
            prid: this.state.prid,
            protocol: this.state.protocol,
            ...this.state.thumbnailTrackURL ? {
                thumbnailTrack: {
                    url: this.state.thumbnailTrackURL
                }
            } : {},
            poster: this.state.poster,
            ...this.state.subtitleURL ? {
                subtitleTracks: [
                    {
                        lang: 'debug',
                        kind: 'subtitle',
                        id: 'debug',
                        label: 'Debug (UI)'
                    }
                ]
            } : {}
        })
    }
}